import { render } from "./role-settings.vue?vue&type=template&id=1050e691"
import script from "./role-settings.vue?vue&type=script&lang=js"
export * from "./role-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__